import type { ValueOf } from '@vy/utils';

export const EVENTS_PAGE_CSV_HEADERS = Object.freeze({
  NAME: 'Event Name',
  TIMESTAMP: 'Timestamp',
  REF: 'Event Ref.',
  CUSTOMER_ALIAS: 'Customer ID',
  CUSTOMER_NAME: 'Customer Name',
  AFFECTED_METERS: 'Affected Meters',
});

export type EventsPageCsvHeaders = ValueOf<typeof EVENTS_PAGE_CSV_HEADERS>;
